// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"SidebarHolder_sidebar__2sHpU","buttonsHolder":"SidebarHolder_buttonsHolder__2iq8K"};